import classes from "./priceCard.module.scss";
import moment from "moment";

function PriceCard(props) {
  return (
    <div className={classes.card}>
      <div className={classes.cardBody}>
        <p className={classes.duration}>{props.title}</p>
      </div>
      <div className={classes.cardFooter}>
        <p className={classes.priceValue}>
          {props.currency + props.price}
          <span> /person </span>
        </p>
      </div>
    </div>
  );
}

export default PriceCard;
